export const BYTES_PER_KILOBYTE = 1024
export const FILE_SIZE_ABBREVIATIONS = ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']

const formatBytes = (bytes: number, decimals = 2) => {
  const bytesValue = Number(bytes)

  if (!bytesValue || bytesValue < 0) {
    return '0B'
  }

  const dm = Math.max(0, decimals)
  const unit = Math.floor(Math.log(bytesValue) / Math.log(BYTES_PER_KILOBYTE))
  const unitAbbr = FILE_SIZE_ABBREVIATIONS[Math.min(unit, FILE_SIZE_ABBREVIATIONS.length - 1)]

  return `${parseFloat((bytesValue / Math.pow(BYTES_PER_KILOBYTE, unit)).toFixed(dm))}${unitAbbr}`
}

export default formatBytes
